export interface Video {
  id: string;
  title: string;
  description: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: number;
  rating: number;
  date: string;
  tags: string[];
  isHot: boolean;
  isNew: boolean;
}

export const videos: Video[] = [
  {
    id: "v001",
    title: "长安十二时辰",
    description: "古装悬疑大剧，讲述大唐天宝三年上元节前夕，长安城陷入危机，死囚张小敬临危受命，与靖安司司丞李必携手在十二时辰内拯救长安的故事。",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20style%2C%20Tang%20dynasty%20warrior%20in%20armor%20standing%20in%20ancient%20city%20at%20night%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20warm%20lantern%20glow%2C%20moody%20atmosphere%2C%20movie%20poster%20aesthetic%2C%20high%20detail&width=800&height=450&seq=video-thumb-v001&orientation=landscape",
    duration: "45:32",
    views: 1280000,
    rating: 9.2,
    date: "2026-08-01",
    tags: ["古装", "悬疑", "热门"],
    isHot: true,
    isNew: false,
  },
  {
    id: "v002",
    title: "星际穿越2：新纪元",
    description: "科幻巨制续作，人类在遥远的星系中寻找新家园，面对未知的宇宙力量，宇航员们必须做出改变人类命运的选择。",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20poster%2C%20astronaut%20floating%20near%20a%20massive%20black%20hole%20with%20wormhole%20vortex%2C%20distant%20galaxy%20background%2C%20cinematic%20lighting%2C%20deep%20space%20aesthetic%2C%20dramatic%20contrast%2C%20movie%20poster%20style%2C%20high%20detail&width=800&height=450&seq=video-thumb-v002&orientation=landscape",
    duration: "148:00",
    views: 3560000,
    rating: 9.5,
    date: "2026-07-28",
    tags: ["科幻", "冒险", "IMAX"],
    isHot: true,
    isNew: true,
  },
  {
    id: "v003",
    title: "欢乐喜剧人 第八季",
    description: "全国顶级喜剧演员齐聚一堂，用笑声传递温暖，每周六晚八点准时开笑，让你忘却烦恼享受欢乐时光。",
    category: "zongyi",
    thumbnail: "https://readdy.ai/api/search-image?query=Bright%20colorful%20variety%20show%20stage%20with%20warm%20studio%20lighting%2C%20comedian%20performers%20on%20stage%2C%20confetti%20and%20cheerful%20atmosphere%2C%20entertainment%20TV%20show%20thumbnail%20style%2C%20vibrant%20colors%2C%20high%20energy%2C%20professional%20lighting&width=800&height=450&seq=video-thumb-v003&orientation=landscape",
    duration: "72:15",
    views: 890000,
    rating: 8.8,
    date: "2026-08-05",
    tags: ["喜剧", "综艺", "搞笑"],
    isHot: true,
    isNew: true,
  },
  {
    id: "v004",
    title: "鬼灭之刃 无限城篇",
    description: "人气动漫最新篇章，炭治郎一行潜入无限城，与上弦之鬼展开最终对决，战斗场面震撼人心，情感刻画细腻入微。",
    category: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=Anime%20style%20action%20scene%2C%20Japanese%20demon%20slayer%20with%20sword%20in%20dynamic%20pose%2C%20flame%20effects%20and%20dramatic%20lighting%2C%20dark%20night%20background%20with%20traditional%20Japanese%20architecture%2C%20vibrant%20color%20grading%2C%20anime%20key%20visual%20style&width=800&height=450&seq=video-thumb-v004&orientation=landscape",
    duration: "24:18",
    views: 2100000,
    rating: 9.7,
    date: "2026-08-02",
    tags: ["热血", "战斗", "日漫"],
    isHot: true,
    isNew: true,
  },
  {
    id: "v005",
    title: "舌尖上的中国 第四季",
    description: "深入探访中国各地美食文化，从街头小吃到宫廷御膳，用镜头记录食物背后的人情故事与文化传承。",
    category: "jilupian",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20style%2C%20steaming%20hot%20noodle%20bowl%20in%20traditional%20kitchen%2C%20warm%20natural%20light%20from%20window%2C%20wooden%20table%20with%20chopsticks%2C%20rustic%20Chinese%20aesthetic%2C%20shallow%20depth%20of%20field%2C%20appetizing%20food%20photography&width=800&height=450&seq=video-thumb-v005&orientation=landscape",
    duration: "50:00",
    views: 560000,
    rating: 9.4,
    date: "2026-07-20",
    tags: ["美食", "人文", "纪录"],
    isHot: false,
    isNew: false,
  },
  {
    id: "v006",
    title: "华语金曲榜 2026",
    description: "年度华语音乐盛典，汇聚周杰伦、林俊杰、邓紫棋等顶级歌手，为你带来最动听的华语音乐盛宴。",
    category: "yinyue",
    thumbnail: "https://readdy.ai/api/search-image?query=Music%20concert%20stage%20with%20colorful%20spotlights%20and%20laser%20effects%2C%20singer%20performing%20on%20stage%2C%20large%20LED%20screen%20background%2C%20enthusiastic%20crowd%20silhouettes%2C%20warm%20golden%20and%20pink%20stage%20lighting%2C%20professional%20concert%20photography%2C%20vibrant%20atmosphere&width=800&height=450&seq=video-thumb-v006&orientation=landscape",
    duration: "90:00",
    views: 780000,
    rating: 9.0,
    date: "2026-08-06",
    tags: ["音乐", "演唱会", "华语"],
    isHot: true,
    isNew: true,
  },
  {
    id: "v007",
    title: "英雄联盟 S16 总决赛",
    description: "全球最顶级电竞赛事，十六支战队争夺召唤师杯，精彩团战、逆风翻盘，每一场都是经典。",
    category: "youxi",
    thumbnail: "https://readdy.ai/api/search-image?query=Esports%20arena%20with%20massive%20LED%20screens%20showing%20game%20action%2C%20professional%20gaming%20teams%20competing%20on%20stage%2C%20dramatic%20blue%20and%20red%20team%20lighting%2C%20packed%20audience%20with%20glow%20sticks%2C%20grand%20stadium%20atmosphere%2C%20esports%20production%20quality&width=800&height=450&seq=video-thumb-v007&orientation=landscape",
    duration: "180:00",
    views: 4500000,
    rating: 9.3,
    date: "2026-08-03",
    tags: ["电竞", "LOL", "赛事"],
    isHot: true,
    isNew: false,
  },
  {
    id: "v008",
    title: "Python 从入门到精通",
    description: "零基础学编程系列，从Python基础语法到实战项目，手把手教你成为编程高手，助你开启程序员之路。",
    category: "zhishi",
    thumbnail: "https://readdy.ai/api/search-image?query=Modern%20coding%20workspace%20with%20laptop%20showing%20Python%20code%20on%20screen%2C%20clean%20minimal%20desk%20setup%2C%20warm%20desk%20lamp%20lighting%2C%20programming%20books%20and%20coffee%20cup%2C%20tech%20education%20aesthetic%2C%20soft%20natural%20light%2C%20professional%20yet%20inviting%20atmosphere&width=800&height=450&seq=video-thumb-v008&orientation=landscape",
    duration: "35:20",
    views: 320000,
    rating: 9.1,
    date: "2026-07-15",
    tags: ["编程", "教程", "入门"],
    isHot: false,
    isNew: false,
  },
  {
    id: "v009",
    title: "流浪地球3",
    description: "中国科幻巅峰之作第三部，太阳急速老化膨胀，人类面临灭顶之灾，全球联合政府启动'移山计划'，带着地球去流浪。",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Epic%20Chinese%20sci-fi%20movie%20scene%2C%20giant%20earth%20engines%20on%20frozen%20planet%20surface%2C%20massive%20plasma%20beams%20shooting%20into%20space%2C%20dramatic%20orange%20and%20blue%20contrast%20lighting%2C%20cinematic%20scale%2C%20movie%20poster%20quality%2C%20grand%20composition&width=800&height=450&seq=video-thumb-v009&orientation=landscape",
    duration: "165:00",
    views: 5200000,
    rating: 9.6,
    date: "2026-07-30",
    tags: ["科幻", "国产", "大片"],
    isHot: true,
    isNew: true,
  },
  {
    id: "v010",
    title: "极限挑战 第十季",
    description: "国民综艺再度回归，六位常驻MC带来全新挑战，在城市中完成各种不可能的任务，笑料不断惊喜连连。",
    category: "zongyi",
    thumbnail: "https://readdy.ai/api/search-image?query=Outdoor%20variety%20show%20thumbnail%2C%20group%20of%20celebrities%20running%20in%20colorful%20urban%20setting%2C%20bright%20sunny%20day%2C%20playful%20energetic%20expressions%2C%20warm%20natural%20lighting%2C%20Korean%20Chinese%20variety%20show%20aesthetic%2C%20vibrant%20colors%2C%20entertainment%20style&width=800&height=450&seq=video-thumb-v010&orientation=landscape",
    duration: "85:00",
    views: 1500000,
    rating: 8.9,
    date: "2026-08-04",
    tags: ["综艺", "挑战", "真人秀"],
    isHot: true,
    isNew: false,
  },
  {
    id: "v011",
    title: "海贼王 最终章",
    description: "路飞与草帽海贼团驶向最终之岛拉夫德鲁，ONE PIECE的秘密即将揭晓，二十年的冒险迎来终极篇章。",
    category: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=Anime%20pirate%20adventure%20scene%2C%20pirate%20ship%20sailing%20on%20vast%20ocean%20under%20dramatic%20sunset%20sky%2C%20golden%20clouds%20with%20warm%20orange%20light%2C%20epic%20adventure%20atmosphere%2C%20Japanese%20anime%20key%20visual%20style%2C%20cinematic%20composition&width=800&height=450&seq=video-thumb-v011&orientation=landscape",
    duration: "24:00",
    views: 3800000,
    rating: 9.8,
    date: "2026-08-07",
    tags: ["冒险", "热血", "日漫"],
    isHot: true,
    isNew: true,
  },
  {
    id: "v012",
    title: "地球脉动 第三季",
    description: "BBC自然纪录片巅峰之作，历时四年拍摄，覆盖七大洲四十个国家，以前所未有的视角展现地球生命的奇迹。",
    category: "jilupian",
    thumbnail: "https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%2C%20majestic%20mountain%20range%20with%20golden%20sunrise%20light%2C%20eagle%20soaring%20in%20sky%2C%20lush%20green%20valley%20below%2C%20cinematic%20aerial%20photography%2C%20warm%20natural%20color%20palette%2C%20BBC%20Earth%20documentary%20quality&width=800&height=450&seq=video-thumb-v012&orientation=landscape",
    duration: "58:00",
    views: 420000,
    rating: 9.9,
    date: "2026-07-25",
    tags: ["自然", "BBC", "4K"],
    isHot: false,
    isNew: false,
  },
  {
    id: "v013",
    title: "说唱新时代 2026",
    description: "中文说唱音乐竞演节目，三十位新生代Rapper同台竞技，用音乐表达态度，谁能成为年度最强说唱新星？",
    category: "yinyue",
    thumbnail: "https://readdy.ai/api/search-image?query=Hip%20hop%20music%20stage%20performance%2C%20rapper%20with%20microphone%20under%20dramatic%20spotlight%2C%20urban%20street%20style%20aesthetic%2C%20neon%20color%20accents%20on%20dark%20background%2C%20cool%20edgy%20music%20show%20thumbnail%2C%20professional%20stage%20photography&width=800&height=450&seq=video-thumb-v013&orientation=landscape",
    duration: "75:00",
    views: 650000,
    rating: 8.7,
    date: "2026-08-01",
    tags: ["说唱", "音乐", "竞演"],
    isHot: false,
    isNew: true,
  },
  {
    id: "v014",
    title: "庆余年 第三季",
    description: "范闲身处权力的漩涡之中，在庆国朝堂与江湖之间周旋，揭开身世之谜的同时也要守护心中所爱。",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%2C%20handsome%20scholar%20in%20traditional%20robes%20standing%20in%20ancient%20palace%20courtyard%2C%20cherry%20blossom%20petals%20falling%2C%20warm%20golden%20sunset%20lighting%2C%20romantic%20yet%20dramatic%20atmosphere%2C%20high%20production%20value%2C%20cinematic&width=800&height=450&seq=video-thumb-v014&orientation=landscape",
    duration: "48:00",
    views: 2800000,
    rating: 9.3,
    date: "2026-08-05",
    tags: ["古装", "权谋", "热门"],
    isHot: true,
    isNew: true,
  },
  {
    id: "v015",
    title: "王者荣耀 巅峰对决",
    description: "顶级战队BO7巅峰对决，职业选手极限操作集锦，从BP博弈到团战拉扯，深度解析每一场精彩比赛。",
    category: "youxi",
    thumbnail: "https://readdy.ai/api/search-image?query=Mobile%20esports%20tournament%20scene%2C%20professional%20players%20competing%20on%20smartphones%20on%20stage%2C%20large%20screens%20showing%20MOBA%20game%20action%2C%20dramatic%20stage%20lighting%20in%20red%20and%20gold%2C%20packed%20arena%2C%20esports%20production%20quality&width=800&height=450&seq=video-thumb-v015&orientation=landscape",
    duration: "60:00",
    views: 1800000,
    rating: 9.0,
    date: "2026-07-29",
    tags: ["王者荣耀", "电竞", "MOBA"],
    isHot: false,
    isNew: false,
  },
  {
    id: "v016",
    title: "摄影大师课",
    description: "国际知名摄影师亲授摄影技巧，从构图、光影到后期处理，帮你从摄影小白蜕变为朋友圈中的拍照达人。",
    category: "zhishi",
    thumbnail: "https://readdy.ai/api/search-image?query=Professional%20photographer%20holding%20camera%20in%20beautiful%20natural%20setting%2C%20golden%20hour%20warm%20lighting%2C%20scenic%20landscape%20background%2C%20creative%20artistic%20atmosphere%2C%20photography%20workshop%20aesthetic%2C%20soft%20bokeh%20effect%2C%20inspirational%20mood&width=800&height=450&seq=video-thumb-v016&orientation=landscape",
    duration: "28:45",
    views: 280000,
    rating: 9.2,
    date: "2026-07-18",
    tags: ["摄影", "教程", "艺术"],
    isHot: false,
    isNew: false,
  },
];

export const getVideosByCategory = (categoryId: string): Video[] => {
  return videos.filter((v) => v.category === categoryId);
};

export const getHotVideos = (): Video[] => {
  return videos.filter((v) => v.isHot);
};

export const getNewVideos = (): Video[] => {
  return videos.filter((v) => v.isNew);
};

export const getVideoById = (id: string): Video | undefined => {
  return videos.find((v) => v.id === id);
};